import React, { useState, useRef, useEffect } from "react";
import CustomButton from "./CustomButton";
import ModalScreen from "./ModalScreen";
import logoutIcon from "../assets/Logout-Icon.png";
import ManageDevicesIcon from "../assets/managedevicesIcon.png";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import { logoutDevice } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import Wrapper from "./shared/Wrapper";
import background_img from "../assets/ManageDeviceBg.png";
import background_manageDevices from "../assets/bg-image.png";
import background_manageDevices_bg from "../assets/ManageDevice.png";




let resolution = window.RESOLUTION;

const ManageDevices = ({ navigate }) => {
  const [state, setState] = useState({
    isLogoutSelected: false,
    isModalButtonSelected: false,
  });
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [modalProps, setModalProps] = useState({});
  const { isLogoutSelected, isEmail } = state;
 
  const devices =
    JSON.parse(localStorage.getItem("user_details") || '{"loggedin_devices": []}').loggedin_devices || [];
 
  const [focusedIndex, setFocusedIndex] = useState(0);
  const buttonsRef = useRef([]);
 
  // Convert timestamp -> readable date
  function formatDate(timestamp) {
    const date = new Date(timestamp * 1000);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  }
 
  // Build device info string
  const deviceInfoStr = devices
    .map((d) => `${d.device_model}/${formatDate(d.created_at)}`)
    .join(", ");
 
  const eventName = `DeviceInfo(${deviceInfoStr})`;
 
  useEffect(() => {
    console.log("here is the showLogoutModal", showLogoutModal);
    if (showLogoutModal) {
      // Remove focus and remove event listener when modal opens
      if (buttonsRef.current[focusedIndex]) {
        buttonsRef.current[focusedIndex].blur();
      }
      setState((prevState) => ({
        ...prevState,
        isLogoutSelected: false,
        isModalButtonSelected: false
      }));
      // Remove the main keydown handler when modal is open
      window.removeEventListener("keydown", ManageDevicesKeyHandler);
    } else {
      // Restore focus and add event listener when modal closes
      console.log("Focusing button at index:", focusedIndex);
      setTimeout(() => {
        if (buttonsRef.current[focusedIndex]) {
          buttonsRef.current[focusedIndex].focus();
        }
        setState((prevState) => ({
          ...prevState,
          isLogoutSelected: true,
          isModalButtonSelected: false
        }));
        // Re-add the keydown handler after modal closes
        window.addEventListener("keydown", ManageDevicesKeyHandler);
      }, 100);
    }
   
    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", ManageDevicesKeyHandler);
    };
  }, [showLogoutModal, focusedIndex]);
 
  useEffect(() => {
    // Matomo Event
    sendTestMatomoEvent({
      eventCategory: "Page",
      eventAction: "View",
      eventName: "DeviceLimitExceeded",
      url: "device-limit",
    });
 
    sendTestMatomoEvent({
      eventCategory: "DeviceLimitExceeded",
      eventAction: "List",
      eventName: eventName,
    });
  }, [eventName]);
 
  const loadData = async () => {
    const myHeaders = {
      Version: window.APP_VERSION,
      Deviceid: localStorage.getItem("macAddress"),
      Devicetoken: localStorage.getItem("uuid"),
      Devicemodel: localStorage.getItem("modelCode"),
      istempuser: true,
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };
 
    let limit_exeed_user_id = JSON.parse(
      localStorage.getItem("user_device_info_id")
    );
 
    let user_device_info_id =
      limit_exeed_user_id.data.user_details.loggedin_devices[focusedIndex]
        .user_device_info_id;
 
    const raw = {
      user_device_info_id: user_device_info_id,
    };

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(raw),
    };

    const body = JSON.stringify(raw);

    // const [fetchedWatchedList] = await Promise.all([
    //   fetchContent(
    //     "/V1/getWatchList/lastupdated/00000000000/page/1",
    //     "GET",
    //     headers
    //   ),
    // ]);

    try {
      //   const [response] = await Promise.all([
      //     fetchContent(
      //     "/V1/logout-device",
      //     "POST",
      //     myHeaders,
      //     body
      //     // JSON.stringify(raw),
      //     // requestOptions
      //   ),
      // ]);

      const response = await logoutDevice(body, myHeaders);
      console.log("logout-device response....", response);
      localStorage.setItem("JWTToken", response?.data?.tokens?.access);
      localStorage.setItem("refresh", response?.data?.tokens?.refresh);
      // const date = `${new Date().getDate().toString().padStart(2, "0")}/${(
      //   new Date().getMonth() + 1
      // )
      //   .toString()
      //   .padStart(2, "0")}/${new Date().getFullYear()}`;

      // // Get the specific device being removed
      // const removedDevice = devices[focusedIndex];
      // const deviceInfo = `${removedDevice.device_model}/${formatDate(removedDevice.created_at)}`;
 
      // sendTestMatomoEvent({
      //   eventCategory: "DeviceLimitExceeded",
      //   eventAction: "DeviceRemoved",
      //   eventName: `DeviceInfo(${deviceInfo})`,
      //   url: "device-limit",
      // });
 
      navigate("WhoWatching", {});
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
 
  // Set focus on the currently focused button
  useEffect(() => {
    if (!showLogoutModal && buttonsRef.current[focusedIndex]) {
      buttonsRef.current[focusedIndex].focus();
    }
  }, [focusedIndex]);
 
  const handleKeyDown = (event, index) => {
    // Prevent navigation when modal is open
    if (showLogoutModal) {
      event.preventDefault();
      return;
    }
   
    if (event.key === "ArrowDown") {
      if (index < devices.length - 1) {
        setFocusedIndex(index + 1);
      }
    } else if (event.key === "ArrowUp") {
      if (index > 0) {
        setFocusedIndex(index - 1);
      }
    }
  };
 
  const handleEnterPress = (index) => {
    setModalProps({
      shouldShowError:true,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      button: ["Logout", "Cancel"],
      iconWdth: "109px",
      iconHeight: "109px",
      modalOKButtonHandler: () => {
        setShowLogoutModal(false);
        loadData();
      },
      modalCANCELButtonHandler: modalCANCELButtonHandler
    });
    setShowLogoutModal(true);
  };

  const handleBackspacePress = () => {
    setModalProps({
      shouldShowError: true,
      errTitle: "Are You Sure, You Want to Go Back?",
      errDescription: "back-to-login",
      errIcon: logoutIcon,
      button: ["Logout", "Cancel"],
      iconWdth: "109px",
      iconHeight: "109px",
      modalOKButtonHandler: (action) => {
        if (action === "Logout") {
          setShowLogoutModal(false);
          // Use the exact same logout logic
          localStorage.removeItem("JWTToken");
          localStorage.removeItem("userInfo");
          localStorage.clear();
          window.appReload();
        }
      },
      modalCANCELButtonHandler: modalCANCELButtonHandler
    });
    setShowLogoutModal(true);
  };
 
  const modalCANCELButtonHandler = () => {
    console.log("Cancel button pressed in modal");
    // First close the modal
    setShowLogoutModal(false);
    setModalProps({
      shouldShowError: false,
    });
   
    // Then restore focus after a small delay
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLogoutSelected: true,
        isModalButtonSelected: false
      }));
     
      if (buttonsRef.current[focusedIndex]) {
        buttonsRef.current[focusedIndex].focus();
      }
    }, 100);
  };
 
  const ManageDevicesKeyHandler = (event) => {
    // This handler should only work when modal is NOT open
    if (showLogoutModal) {
      return;
    }
   
    if (event.keyCode !== undefined) {
      switch (event.keyCode) {
        case 8: // Backspace key
        case 461: // Back key on some remotes
        case 10009: // Back key on Roku remote
          event.preventDefault(); // Prevent browser back navigation
          handleBackspacePress();
          break;
        case 13: // Enter key
          if (buttonsRef.current[focusedIndex]) {
            handleEnterPress(focusedIndex);
          }
          break;
        case 38: // Up arrow
          console.log("Up key pressed");
          if (focusedIndex > 0) {
            setFocusedIndex(focusedIndex - 1);
          }
          break;
        case 40: // Down arrow
          console.log("Down key pressed");
          if (focusedIndex < devices.length - 1) {
            setFocusedIndex(focusedIndex + 1);
          }
          break;
        default:
          break;
      }
    }
  };
 
  return (
    <div style={styles.outerContainer}>
      <div style={styles.container}>
        <div style={styles.leftSection}>
          <div style={styles.iconContainer}>
            <div style={styles.icon}>
              <img
                src={ManageDevicesIcon}
                alt="Manage Device"
                style={styles.iconImage}
              />
              <p style={styles.subtitle}>
                {devices?.length} devices are currently streaming out of{" "}
                {devices?.length} allowed devices.
              </p>
            </div>
          </div>
        </div>
        <div style={styles.divider} />
        <div style={styles.rightSection}>
          <h2 style={styles.title}>Too many login!</h2>
          <p style={styles.subtitle}>
            Your account is currently in use on too many devices. Please logout
            any of the device to login.
          </p>
          <ul style={styles.deviceList}>
            {devices.map((device, index) => (
              <li key={index} style={styles.deviceItem}>
                <div>
                  <strong>{device.device_model}</strong>
                  <p style={styles.deviceDate}>
                    Last Used:{" "}
                    {new Date(device.created_at * 1000).toLocaleString()}
                  </p>
                </div>
                <Wrapper 
                  manageDevice="true"
                >
                  <button
                  //   fontSize={resolution === "FHD" ? "24px" : "24px"}
                  //   defaultSelected={isLogoutSelected}
                  //   width={resolution === "FHD" ? "16vw" : "16vw"}
                  //   height={resolution === "FHD" ? "7vh" : "7vh"}
                  //   left={resolution === "FHD" ? "19vw" : "19vw"}
                  //   right={resolution === "FHD" ? "0vw" : "0vw"}
                  //   border={isEmail ? "2px solid #FF671F" : "2px solid #393939"}
                  // onFocus={() => setFocusedIndex(index)} // Set focus index when button is focused
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onClick={() => handleEnterPress(index)}
                    ref={(el) => (buttonsRef.current[index] = el)}
                    style={{
                      width: "8.84rem",
                      height: "2.91rem",                     
                      backgroundColor: index === focusedIndex ? "#EC008C" : "#0E1653",color: "#FFF", border: "none",
                      borderRadius: "11px",
                      padding: "10px 20px",
                      cursor: "pointer",
                      fontSize: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Log Out
                  </button>
                </Wrapper>

              </li>
            ))}
          </ul>
        </div>
      </div>
      {showLogoutModal && (
        <ModalScreen {...modalProps} />
        //   <ModalScreen
        //   shouldShowError={shouldShowModal}
        //   errTitle={errTitle}
        //   errDescription={errDescription}
        //   errIcon={errIcon}
        //   button={button}
        //   iconWdth={iconWdth}
        //   iconHeight={iconHeight}
        //   modalOKButtonHandler={modalOKButtonHandler}
        //   modalCANCELButtonHandler={modalCANCELButtonHandler}
        // />
      )}
    </div>
  );
};
 
const styles = {
  outerContainer: {
     backgroundImage: `url(${background_img})`,
    
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100vh",
    // padding: '20px',
    // border: "2px solid #FFF",
    // borderRadius: "16px",
    backgroundColor: "#000",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "79%",
    height: "79%",
    color: "#FFF",
    border: "2px solid #fff",
    borderRadius: "22px",
    fontFamily: "Arial, sans-serif",
     backgroundImage: `url(${background_manageDevices_bg})`,

  },
  leftSection: {
    width: "45%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  iconContainer: {
    textAlign: "center",
    color: "#FFF",
  },
  icon: {
    margin: "20px auto",
    borderRadius: "8px",
    overflow: "hidden",
  },
  iconImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  divider: {
    width: "1px",
    height: "70%",
    backgroundColor: "#fff",
  },
  rightSection: {
    width: "45%",
    padding: "20px",
    textAlign: "center",
  },
  title: {
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  subtitle: {
    fontSize: "1rem",
    marginBottom: "20px",
  },
  deviceList: {
    listStyleType: "none",
    padding: 0,
    textAlign: "left",
    // backgroundColor: "#0E1653",
  },
  deviceItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // backgroundColor: "#0E1653",
    padding: "10px",
    marginBottom: "10px",
    borderRadius: "8px",
  },
  deviceDate: {
    fontSize: "0.8rem",
    color: "#aaa",
  },
};
 
export default ManageDevices;